import { useTheme } from '@mui/material';
import { colors } from '../../constants/colors';

import { IStyles } from '../../interfaces/styles';
import { ScreenSizes } from '@interfaces/index';

const hoverStyles = {
  '&:hover': {
    backgroundColor: 'transparent',
    '& p': {
      color: colors.oxford,
      opacity: 0.8,
    },
  },
};

export const useStyles = (): IStyles => {
  const { breakpoints } = useTheme();

  return {
    dropdown: {
      m: 0,
      minWidth: 80,
      border: 'none',
      '& fieldset': {
        border: 'none',
      },
    },
    select: {
      opacity: 0.5,
      '& fieldset': {
        border: 'none',
      },
      '& .MuiSelect-select': {
        p: 0,
        '& p': {
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '18px',
          color: colors.black,
          [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
            fontSize: '12px',
            lineHeight: '14px',
          },
        },
      },
    },
    menuItem: {
      '&.Mui-selected': {
        backgroundColor: 'transparent',
        '& p': {
          color: colors.oxford,
          opacity: 0.8,
        },
        ...hoverStyles,
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
      ...hoverStyles,
    },
    selectItemText: {
      fontWeight: 500,
      fontSize: 16,
      lineHeight: 1,
      color: colors.oxford_60,
      width: '100%',
    },
    noDevices: {
      marginLeft: 4,
    },
  };
};
